import { AccountFeatureFlag, useFeatureFlag } from '@/services/auth/feature-flags';
import { NewslettersFilters } from '../components/newsletters-filters';
import { StaleGoalsRedirect } from '../components/stale-goals-redirect';
import { useBroadcastsListContext } from '../list-context';
import { useNewslettersTabSearch } from '../use-tab-search';

/**
 * The one-time sends tab's body, inside the Broadcasts frame, which already owns the search,
 * the tab bar and the pagination. The table goes under the filters (FPS-2625).
 */
export default function OneTimeSendsTab() {
  const showGoals = useFeatureFlag(AccountFeatureFlag.ShowGoals);
  const [search, update] = useNewslettersTabSearch();
  const { newslettersQuery } = useBroadcastsListContext();

  if (!showGoals && search.goalIds != null) {
    return <StaleGoalsRedirect tab="one_time_sends" search={search} />;
  }

  return <NewslettersFilters search={search} totals={newslettersQuery?.data?.totals} onChange={update} />;
}
